import React, { FC, memo } from "react";

import { Icon } from "@/components/Icon";
import { ICustomField } from "@/data/custom-fields";
import { useFormats } from "@/hooks/Formats";

import "./_custom-field.scss";

export interface ICustomFieldValueProps {
  type: ICustomField["type"];
  value: ICustomField["value"];
}

export const CustomFieldValue: FC<ICustomFieldValueProps> = memo(({ type, value }) => {
  const { formatDate } = useFormats();
  switch (type) {
    case "BOOLEAN":
      return value === "true" ? <Icon icon="checkbox" color="success" /> : <Icon icon="close" color="error" />;
    case "NUMBER":
      return <>{Number(value).toString()}</>;
    case "DATE":
      return <>{formatDate(value)}</>;
    case "TEXT":
      return <span className="custom-text-field">{value}</span>;
    default:
      return <>{value}</>;
  }
});
